<template>
  <div :id="content.idHTML" :class="jel_getClassObject(content)">
    <GroupeRadio v-model="canafe" :content="getContent()"></GroupeRadio>
  </div>
</template>

<script>
import GroupeRadio from '@/components/formulaire/base/GroupeRadio.vue';

export default {
  name: 'FormulaireCanafe',
  components: {
    GroupeRadio,
  },

  props: { content: { type: Object, required: true } },
  computed: {
    canafe: {
      get() {
        return this.$store.state.compte.canafe;
      },
      set(value) {
        this.$store.commit('compte/SET_CANAFE', value);
      },
    },
  },
  methods: {
    getContent() {
      // eslint-disable-next-line vue/no-mutating-props
      this.content.format = 'boutons';
      // eslint-disable-next-line vue/no-mutating-props
      this.content.type = 'texte';
      // eslint-disable-next-line vue/no-mutating-props
      this.content.largeurBouton = 'identique';
      return this.content;
    },
  },
};
</script>
